import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";
import DocumentTypeMapper from "../../documentTypes/service/DocumentTypeMapper";
import DocumentTypeParamMapper from "../../documentTypes/service/DocumentTypeParamMapper";
import Constants from "../common/Constants";

export default class UpdateCaseLawDocumentTypeInteractor {
  private resource: UpdateResourceInteractor<IDocumentType>;

  constructor({ updateResource }: any) {
    this.resource = updateResource;
  }

  async execute(model: IDocumentType) {
    const result = await this.resource.execute(
      `${Constants.caseLawDocumentTypePath}`,
      DocumentTypeMapper,
      DocumentTypeParamMapper,
      model,
      model.code
    );

    return result;
  }
}
